import styles from './index.module.less'
import useWorkshopStore from '@/store/workshop.ts'
import { useShallow } from 'zustand/react/shallow'
import ApplicationList from './ApplicationList.tsx'
import { Empty, Skeleton } from 'antd'
import useAuthMenu from '@/hooks/useAuthMenu.ts'
import useGlobalStore from '@/store'

const ApplicationFavor = () => {
  const { appCommonlyUsed, appCollectLoading } = useWorkshopStore(
    useShallow((state: any) => ({
      appCommonlyUsed: state.appCommonlyUsed,
      appCollectLoading: state.appCollectLoading,
    }))
  )

  const { menuLoading } = useGlobalStore(
    useShallow((state: any) => ({
      menuLoading: state.menuLoading,
    }))
  )

  const authMenu = useAuthMenu(appCommonlyUsed)
  const loading = appCollectLoading || menuLoading
  return (
    <div className={styles.applicationFavor}>
      <div className={styles.favorContent}>
        <ApplicationList
          dataSource={authMenu}
          wrap={false}
          spanProps={{ span: 8, xxl: 6 }}
          commonlyRemoveText="移除"
          showEmpty={false}
          size="small"
        />
      </div>

      {!loading && !appCommonlyUsed.length ? (
        <div className={styles.favorEmpty}>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      ) : null}

      {loading ? (
        <div style={{ margin: '0 10px' }}>
          <Skeleton active />
        </div>
      ) : null}
    </div>
  )
}

export default ApplicationFavor
